/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TerminalEventDto } from './TerminalEventDto';
import {
    TerminalEventDtoFromJSON,
    TerminalEventDtoFromJSONTyped,
    TerminalEventDtoToJSON,
    TerminalEventDtoToJSONTyped,
} from './TerminalEventDto';

/**
 * 
 * @export
 * @interface PageTerminalEventDto
 */
export interface PageTerminalEventDto {
    /**
     * 
     * @type {number}
     * @memberof PageTerminalEventDto
     */
    currentPageNo: number;
    /**
     * 
     * @type {boolean}
     * @memberof PageTerminalEventDto
     */
    isFirst: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageTerminalEventDto
     */
    isLast: boolean;
    /**
     * 
     * @type {number}
     * @memberof PageTerminalEventDto
     */
    numberOfElements: number;
    /**
     * 
     * @type {Array<TerminalEventDto>}
     * @memberof PageTerminalEventDto
     */
    pageContent: Array<TerminalEventDto>;
    /**
     * 
     * @type {number}
     * @memberof PageTerminalEventDto
     */
    pageSize: number;
    /**
     * 
     * @type {number}
     * @memberof PageTerminalEventDto
     */
    totalElements: number;
    /**
     * 
     * @type {number}
     * @memberof PageTerminalEventDto
     */
    totalPages?: number | null;
}

/**
 * Check if a given object implements the PageTerminalEventDto interface.
 */
export function instanceOfPageTerminalEventDto(value: object): value is PageTerminalEventDto {
    if (!('currentPageNo' in value) || value['currentPageNo'] === undefined) return false;
    if (!('isFirst' in value) || value['isFirst'] === undefined) return false;
    if (!('isLast' in value) || value['isLast'] === undefined) return false;
    if (!('numberOfElements' in value) || value['numberOfElements'] === undefined) return false;
    if (!('pageContent' in value) || value['pageContent'] === undefined) return false;
    if (!('pageSize' in value) || value['pageSize'] === undefined) return false;
    if (!('totalElements' in value) || value['totalElements'] === undefined) return false;
    return true;
}

export function PageTerminalEventDtoFromJSON(json: any): PageTerminalEventDto {
    return PageTerminalEventDtoFromJSONTyped(json, false);
}

export function PageTerminalEventDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageTerminalEventDto {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPageNo': json['currentPageNo'],
        'isFirst': json['isFirst'],
        'isLast': json['isLast'],
        'numberOfElements': json['numberOfElements'],
        'pageContent': ((json['pageContent'] as Array<any>).map(TerminalEventDtoFromJSON)),
        'pageSize': json['pageSize'],
        'totalElements': json['totalElements'],
        'totalPages': json['totalPages'] === undefined ? undefined : json['totalPages'] === null ? null : json['totalPages'],
    };
}

export function PageTerminalEventDtoToJSON(json: any): PageTerminalEventDto {
    return PageTerminalEventDtoToJSONTyped(json, false);
}

export function PageTerminalEventDtoToJSONTyped(value?: PageTerminalEventDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPageNo': value['currentPageNo'],
        'isFirst': value['isFirst'],
        'isLast': value['isLast'],
        'numberOfElements': value['numberOfElements'],
        'pageContent': ((value['pageContent'] as Array<any>).map(TerminalEventDtoToJSON)),
        'pageSize': value['pageSize'],
        'totalElements': value['totalElements'],
        'totalPages': value['totalPages'],
    };
}

